<template>
  <div
    class="app-container clearfix"
    v-loading="openloading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <div class="left300 right-20">
      <el-card class="el-brand">
        <div slot="header" class="clearfix">
          <span class="ptitle">问题分类</span>
        </div>

        <div
          v-for="(item, index) in questionTypeList"
          :class="{ activelist: active == item.name, listitem: true }"
          :key="index"
          @click="selectType(item._id, item.name)"
        >
          &nbsp;&nbsp;{{ item.name }}
        </div>
      </el-card>
    </div>
    <div class="contentMode">
      <el-row :gutter="20">
        <el-card>
          <el-col>
            <el-input
              placeholder="搜索"
              style="float: left; width: 30%"
              v-model="queryParams.ArchiveFilter"
              size="medium"
              suffix-icon="el-icon-search"
              v-on:input="search"
            ></el-input>

            <el-button
              style="float: right; padding: 3px 0"
              size="mini"
              type="primary"
              icon="el-icon-plus"
              class="pull-right"
              @click="addInfo"
              v-if="isGranted('Pages.QuestionAdmins.Create')"
              >新增</el-button
            >
          </el-col>
          <el-col :span="24">
            <el-table
              :data="tableData"
              size="mini"
              style="width: 100%; margin-top: 10px"
              border
            >
              <el-table-column
                label="操作"
                v-if="
                  isGranted('Pages.QuestionAdmins.Delete') ||
                    isGranted('Pages.QuestionAdmins.Edit')
                "
              >
                <template slot-scope="scope">
                  <el-tooltip content="编辑" placement="bottom">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      @click="editRow(scope.row)"
                      size="mini"
                      v-if="isGranted('Pages.QuestionAdmins.Edit')"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="bottom">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      @click="deleteEntity(scope.row._id)"
                      size="mini"
                      v-if="isGranted('Pages.QuestionAdmins.Delete')"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="问题编码" align="center">
                <template slot-scope="scope">{{
                  scope.row.questionCode
                }}</template>
              </el-table-column>
              <el-table-column prop="name" label="问题标题" align="center">
                <template slot-scope="scope">{{
                  scope.row.questionTitle
                }}</template>
              </el-table-column>
              <el-table-column prop="name" label="问题类型" align="center">
                <template slot-scope="scope">{{
                  scope.row.questionTypeName
                }}</template>
              </el-table-column>
            </el-table>
            <pagerBar
              ref="refPagerBar"
              :apiURL="questionAdminUrl"
              :GetData="initData"
              :queryParam="queryParams"
              :errorFunc="closeOpenloading"
            ></pagerBar>
          </el-col>
        </el-card>
      </el-row>
    </div>
    <el-dialog
      v-el-drag-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="38%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-width="110px"
        :model="formLabel"
        :rules="rules"
        ref="QuestionInfoEditForm"
      >
        <el-form-item label="问题编码" prop="questionCode">
          <el-input
            v-model="formLabel.questionCode"
            placeholder="请输入问题编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题标题" prop="questionTitle">
          <el-input
            v-model="formLabel.questionTitle"
            placeholder="请输入问题标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题分类" prop="questionType">
          <el-input
            v-model="formLabel.questionTypeName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="解决方案" prop="questionSolution">
          <quill-editor
            ref="text1"
            v-model="formLabel.questionSolution"
            class="myQuillEditor"
            :options="editorOption"
            placeholder="请输入解决方案"
            size="mini"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="SaveEntity()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
  data() {
    return {
      editorOption: {},
      active: "", //菜单点击高亮效果
      //TODO
      openloading: true,
      dialogVisible: false, // 弹窗显示
      tableData: [],
      questionTypeList: [],
      //得到科目类别的键值对
      getQuestionTypesUrl: config.BASE_Middle_API + "QuestionClass/GetAllList",
      //科目字段列表数据获取
      questionAdminUrl: config.BASE_Middle_API + "QuestionAdmin/GetAll",
      //新增or修改
      createOrEditUrl: config.BASE_Middle_API + "QuestionAdmin",
      //删除
      deleteUrl: config.BASE_Middle_API + "QuestionAdmin/Delete",
      //得到信息实体
      GetQuestionTypeUrl:
        config.BASE_Middle_API + "QuestionClass/GetQuestionClassForEdit",
      //得到信息实体
      GetEntityUrl: config.BASE_Middle_API + "QuestionAdmin/Edit",
      title: "新增问题详情",
      operation: "",
      formLabel: {
        _id: null,
        questionTitle: "",
        questionCode: "",
        questionTypeCode: 0,
        questionSolution: "",
        questionTypeName: "",
        questionTypeId: null,
      },
      //已选择的问题类型ID
      selectTypeId: 0,
      queryParams: { Filter: "", ArchiveFilter: "" },
      rules: {
        questionTitle: [
          { required: true, message: "请输入问题标题", trigger: "blur" },
        ],
        questionCode: [
          { required: true, message: "请输入问题编码", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    pagerBar,
    quillEditor,
  },
  mounted: function() {
    this.getTypeKeyValues();
  },
  methods: {
    search: function(e) {
      this.initData();
    },
    getTypeKeyValues() {
      const _this = this;
      AjaxHelper.get(_this.getQuestionTypesUrl)
        .then(function(response) {
          if (response.success) {
            _this.questionTypeList = response.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectType(id, name) {
      const _this = this;
      _this.active = name;
      _this.selectTypeId = id;
      _this.queryParams.Filter = id;
    },
    closeOpenloading() {
      this.openloading = false;
    },
    //新增科目字段
    addInfo() {
      if (this.selectTypeId == 0) {
        this.$notify({
          title: "提示",
          message: "请先选择左侧问题分类",
          type: "error",
          position: "bottom-right",
        });
        return;
      }
      this.clearformLabel();
      this.dialogVisible = true;
      this.title = "新增问题";
      this.operation = "add";
      const _this = this;
      let confirmData = { _id: _this.selectTypeId };

      AjaxHelper.get(_this.GetQuestionTypeUrl, confirmData)
        .then(function(response) {
          if (response.success) {
            _this.dialogVisible = true;
            _this.formLabel.questionTypeName = response.result.name;
            _this.formLabel.questionTypeCode = response.result.code;
            _this.formLabel._id = null;
            _this.formLabel.questionTypeId = _this.selectTypeId;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      this.dialogVisible = true;
    },
    clearformLabel() {
      const _this = this;
      _this.formLabel._id = null;
      _this.formLabel.questionTitle = "";
      _this.formLabel.questionCode = "";
      _this.formLabel.questionSolution = "";
      _this.formLabel.questionTypeCode = null;
      _this.formLabel.questionTypeName = "";
      _this.formLabel.questionTypeId = null;
    },
    initData(d) {
      const _this = this;
      _this.tableData = d;
      _this.openloading = false;
    },
    //编辑
    editRow(row) {
      const _this = this;
      _this.title = "编辑问题";
      _this.operation = "edit";
      this.dialogVisible = true;
      _this.formLabel = Object.assign({}, row);
      console.log(row);
      //   let confirmData = { tempId: id };
      //   AjaxHelper.get(_this.GetEntityUrl, confirmData)
      //     .then(function (response) {
      //       if (response.success) {
      //         _this.dialogVisible = true;
      //         console.log(response.result);
      //         _this.formLabel = response.result.questionInfo;
      //         _this.formLabel.questionTypeName = response.result.questionTypeName;
      //       }
      //     })
      //     .catch(function (error) {
      //       console.log(error);
      //     });
    },
    deleteEntity(deletedId) {
      const _this = this;
      this.$confirm("确定删除该问题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          AjaxHelper.delete(_this.deleteUrl, {
            tempId: deletedId,
          })
            .then(function(response) {
              if (response.success) {
                _this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                _this.Refresh();
              }
            })
            .catch(function(error) {
              _this.$message({
                type: "danger",
                message: error,
              });
            });
        })
        .catch((e) => {
          _this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //保存
    SaveEntity() {
      const _this = this;
      this.$refs["QuestionInfoEditForm"].validate((valid) => {
        let postUrl = "";
        if (_this.operation == "edit") {
          postUrl = "/Edit";
        } else {
          postUrl = "/Add";
        }
        _this.formLabel.tempId = _this.formLabel._id;

        if (valid) {
          AjaxHelper.post(_this.createOrEditUrl + postUrl, _this.formLabel)
            .then(function(response) {
              if (response.success) {
                _this.$message({
                  type: "success",
                  message: "操作成功",
                });
                _this.pagesize = 1;
                _this.clearformLabel();
                _this.Refresh();
                _this.dialogVisible = !_this.dialogVisible;
              } else {
                _this.$message({
                  type: "error",
                  message: response.Messages[0],
                });
              }
            })
            .catch(function(error) {
              _this.$message({
                type: "error",
                message: error,
              });
            });
        }
      });
    },
    Refresh() {
      this.$refs.refPagerBar.Refresh();
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style scoped="scoped">
dt,
dd {
  margin: 0;
  padding: 0;
}
</style>
